import { atom } from "recoil";

export const uploadedFiles6DOFState = atom({
  key: "uploadedFiles6DOFState",
  default: [],
});
export const uploadMultiple6DOFState = atom({
  key: "uploadMultiple6DOFState",
  default: {
    parameter_json: true,
    mass_and_shape_response: true,
    aero_coefficients_ascent: true,
    aero_coefficients_ascent_2: true,
    wind_model: true,
    thrust_profile: true,
    aero_coefficients_descent: true,
    target_attitude_rate_ascent: true,
    target_attitude_rate_descent: true,
    target_attitude_ascent: true,
    target_attitude_descent: true,
  },
});
